import React, { Component } from 'react'
import { FormattedMessage, injectIntl } from 'react-intl'

import * as formatters from '../../../common/formatters'

import CompanyCostCentersEditForm from './CompanyCostCentersEditForm'

// eslint-disable-next-line react/prefer-stateless-function
class CompanyCostCentersEdit extends Component {
    render() {
        document.title = formatters.titleFormatter(this.props.intl.formatMessage({ id: 'modules.companyCostCenters.heading' }))

        return (
            <div className="page-inner">
                <div id="main-wrapper">
                    <div className="row">
                        <div className="col-md-8 col-md-offset-2 col-lg-6 col-lg-offset-3 col-xl-4 col-xl-offset-4">
                            <div className="panel panel-white">
                                <div className="panel-body panel-padding">
                                    <div className="panel-head">
                                        <h4>
                                            <FormattedMessage id="modules.companyCostCenters.heading" /> -{' '}
                                            {this.props.match.params.companyCostCenterID ? (
                                                <FormattedMessage id="fields.itemEdit" />
                                            ) : (
                                                <FormattedMessage id="fields.itemCreate" />
                                            )}
                                        </h4>
                                    </div>

                                    <CompanyCostCentersEditForm companyCostCenterID={this.props.match.params.companyCostCenterID} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default injectIntl(CompanyCostCentersEdit)
